import * as Sentry from "@sentry/react";
import { Component, type ReactNode } from "react";

type Props = {
  fallback: ReactNode;
  children: ReactNode;
  resetKey?: string;
};

export class ChatErrorBoundary extends Component<
  Props,
  {
    hasError: boolean;
    resetKey?: string;
  }
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, resetKey: props.resetKey };
  }

  static getDerivedStateFromProps(props: Props, state: { resetKey?: string }) {
    if (props.resetKey !== state.resetKey) {
      return { hasError: false, resetKey: props.resetKey };
    }
    return null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: unknown) {
    Sentry.captureException(error, {
      extra: {
        info,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback as null;
    }

    return this.props.children as null;
  }
}
